export enum AssetClass {
  FX = 'FX',
  FX_SWAP = 'FX',
  OPTIONS = 'OPTIONS',
}
